module.exports = __webpack_public_path__ + "img/icon_web03_zizhi3@2x.dae75048.png";